/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
import { useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Validators } from '@/lib/Validators';
import './AdminLogin.css';

const AdminLogin = () => {
    const navigate = useNavigate();

    const [formControls, setFormControls] = useState({
        email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email()] },
        password: { value: '', valid: false, error: '', validators: [Validators.required()] }
    });

    const [formValid, setFormValid] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [pwdtype, setPwdtype] = useState('password');
    const [error, setError] = useState('');

    const onInputChange = (controlName, event) => {
        const updatedControls = {
            ...formControls,
            [controlName]: Validators.validateFormControl(
                formControls[controlName],
                event.target.value
            )
        };

        setFormControls(updatedControls);
        setFormValid(Validators.validateForm(updatedControls));
    };

    const onSignin = () => {
        setFormLoading(true);
        setError('');
        navigate('/admin-booking');

        // const payload = {
        //   data: {
        //     username: formControls.email.value,
        //     password: Buffer.from(formControls.password.value, 'utf-8').toString('base64'),
        //     'keep-user-logged-in': false
        //   }
        // };

        // postApi(loginApi, payload, false)
        //   .then(response => {
        //     setFormLoading(false);
        //     login(response.data);
        //     setUser().then(() => {
        //       navigate('/');
        //     });
        //   })
        //   .catch(() => {
        //     setFormLoading(false);
        //     setError(
        //       "Sorry, we couldn't find an account with that email and password combination. Please try again or select the Forgot Password link."
        //     );
        //   });
    };

    return (
        <div className="signin w-100">
            <div className="scontainer">
                <div className="sigincontent">
                    <div className="shadow-lg px-5 pb-5 rounded">
                        <img 
                            src="https://customer-assets.emergentagent.com/job_scenic-getaway/artifacts/8kzzd56i_FullLogo_Transparent_NoBuffer.png" 
                            alt="Luxtansa Resorts"  className="logo-image"
                        />                        
                        <div className='text-center admin-login mt-3'>Admin Login</div>
                        <div className='heading'>Luxtansa Resorts Management</div>
                        <Form className="w-100 d-flex flex-column justify-content-center my-1 mt-3">
                            <div className="form-group mb-3">
                                <Label htmlFor="email">Email</Label>
                                <Input type="text" name="email" label="Email" placeholder="Email" value={formControls.email.value} error={formControls.email.error}
                                    onChange={(e) => onInputChange('email', e)} />
                            </div>

                            <div className="form-group mb-3">
                                <Label htmlFor="password">Password</Label>
                                <Input type={pwdtype} name="password" label="Password" placeholder="Password" value={formControls.password.value} error={formControls.password.error}
                                    onChange={(e) => onInputChange('password', e)} setType={setPwdtype} />
                            </div>
                            
                            {/* <div className="rowcont justify-content-between my-1">
                                <Form.Check className='d-flex gap-2' type="checkbox" id="signin-checkbox" label="Keep me signed in" />
                                <div className="d-flex align-items-center">
                                    <Link className="d-flex" to="/forgot-password">
                                        <small className="text-n">Forgot Password?</small>
                                    </Link>
                                </div>
                            </div> */}

                            <div className="mt-3 text-center text-m">
                                {error && <span className="text-danger">{error}</span>}
                            </div>

                            <Button type="button" className="w-100 d-flex p-2 my-2 align-items-center justify-content-center btn btn-secondary sign-btn rounded"
                                onClick={onSignin} disabled={!formValid}>
                                Login {formLoading && (
                                    <Spinner className="ms-2" as="span" animation="border" role="status" aria-hidden="true" />
                                )}
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
